import FacteurPonderationModal from '@/views/consultations/en-cours/cpn/modal-facteur-ponderation'

export default {
  name: 'facteur-ponderation',
  components: {FacteurPonderationModal},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    consultationEnCours() {
      return this.$store.getters['consultationPatientEnCours']
    },

    facteursPonderations(){
      return this.$store.getters["facteursPonderations"];
    },
  },
  mounted () {
    this.$store.dispatch('getFacteursPonderations',{id:this.consultationEnCours.id,enCours:true});
  },
  methods: {
    

  }
}


